// extracted by mini-css-extract-plugin
export default {"btn":"sidebarbutton_btn__Ams37"};